import { Component } from 'react'
import PT from 'prop-types'
import { withRouter } from 'react-router-dom'
import ReactGA from 'react-ga'

class GATracker extends Component {
  componentDidMount() {
    const { pathname } = this.props.location
    ReactGA.pageview(pathname)
  }

  componentDidUpdate(prevProps) {
    const { pathname } = this.props.location
    if (prevProps.location.pathname !== pathname) {
      ReactGA.pageview(pathname)

      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    }
  }

  render() {
    return null
  }
}

GATracker.propTypes = {
  location: PT.shape({
    pathname: PT.string.isRequired,
  }).isRequired,
}

export default withRouter(GATracker)



// WEBPACK FOOTER //
// ./src/GATracker.js